import { toast } from "react-toastify";
import { isBackendOffline } from "./backendStatus";

// Regra do app: só um toast na tela por vez. Ao abrir um novo, o que estiver
// aberto é removido. Aplicado direto nos métodos do `toast` do react-toastify
// para valer em todos os call sites sem trocar os imports.
const TYPES = ["success", "error", "info", "warning", "dark"];

TYPES.forEach((type) => {
  const original = toast[type];

  toast[type] = (content, options) => {
    // Com o backend fora do ar, erros e avisos são consequência da queda
    // (mostrada só na sidebar): descarta.
    if ((type === "error" || type === "warning") && isBackendOffline()) return null;
    // Mesmo toastId já aberto: o react-toastify ignora a duplicata, então
    // não pode remover o atual (senão a tela fica sem nenhum).
    const sameToastActive = options?.toastId && toast.isActive(options.toastId);
    if (!sameToastActive) toast.dismiss();
    return original(content, options);
  };
});

toast.warn = toast.warning;
